interface DividerProps {
  text?: string;
}

export default function Divider({ text = 'or' }: DividerProps) {
  return (
    <div className="relative w-full">
      <div className="absolute inset-0 flex items-center">
        <div className="w-full border-t border-gray-200" />
      </div>
      <div className="relative flex justify-center">
        <span className="px-4 bg-white text-xs font-medium text-gray-400 uppercase tracking-wider">{text}</span>
      </div>
    </div>
  );
}
